import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { reqInquiryActionTypes } from '../actions/actionTypes';

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
});

const ReqInquiry = (state = { ...basicListAddEditDltInitialState }, action = null) => {
  switch (action.type) {
    case reqInquiryActionTypes.SET_REQINQ_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case reqInquiryActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicListAddEditDltInitialState;
    default:
      return state;
  }
};

export default ReqInquiry;
